import React from 'react';
import { Skeleton } from '@skin-seoul/design-system';

const CartProductCardSkeleton = () => {
  return (
    <div className="flex w-full gap-5 relative pt-[27px] px-[22px] pb-8">
      <div className="flex items-center justify-center min-w-[112px] w-[112px] h-[112px] border border-neutral-20 rounded-[8px] p-1">
        <Skeleton className="w-[100px] h-[100px] rounded-[4px]" />
      </div>

      <div className="flex flex-col w-full justify-between">
        <div className="flex flex-col justify-between w-full mb-3">
          <div className="flex flex-row gap-1 items-center justify-between">
            <Skeleton className="h-4 w-[70%]" />
            <Skeleton className="w-[24px] h-[24px] rounded-[12px]" />
          </div>

          <div className="flex flex-row gap-2 mt-1">
            <Skeleton className="w-[60px] h-[14px]" />
            <Skeleton className="w-[60px] h-[14px]" />
          </div>
        </div>

        <div className="flex justify-between w-full items-center">
          <Skeleton className="w-[80px] h-[24px] rounded-[4px]" />

          <Skeleton className="w-[60px] h-[24px] rounded-[4px]" />
        </div>
      </div>
    </div>
  );
};

export default CartProductCardSkeleton;
